export default __webpack_public_path__ + "static/media/fingers.8eb05bd1.png";